import MealsSummary from "./MealsSummary"
import AvailableMeals from "./AvailableMeals"
import React from "react"

function Meals(){
    return(
        <>
            <MealsSummary/>
            <AvailableMeals/>
        </>
    )
}

export default Meals